// @flow
import {
    ACQUIRE_DEVICES,
    CLOSE_PLACEMENT_ADVICE,
    FINISH_INSTALL_DEVICES,
    FINISHED_INSTALL_DEVICES,
    PLACEMENT_ADVICE_TYPES,
    START_ACQUIRE_DEVICES,
    STOP_ACQUIRE_DEVICES,
    UNLOAD_INSTALL_DEVICES
} from './constants';

import { deviceTypes } from '~/core/constants/devices';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import type { StateType } from './types';

const initialState: StateType = {
    devices: [],
    errors: 0,
    finishedAcquiring: false,
    installInProgress: false,
    placementAdvice: PLACEMENT_ADVICE_TYPES.NOT_SHOWN,
    startTime: undefined
};

export default handleActions(
    {
        [ACQUIRE_DEVICES]: handleReduce(
            (state, { payload: devices }) => {
                let placementAdvice = state.placementAdvice;

                if (placementAdvice !== PLACEMENT_ADVICE_TYPES.SHOWN) {
                    const adviceNeeded = devices.some(({ type }) => type === deviceTypes.SIGNAL_BOOSTER);
                    placementAdvice = adviceNeeded ? PLACEMENT_ADVICE_TYPES.SHOW : PLACEMENT_ADVICE_TYPES.NOT_SHOWN;
                }

                return {
                    ...state,
                    devices,
                    placementAdvice,
                    errors: 0
                };
            },
            state => ({ ...state, errors: state.errors + 1 })
        ),
        [CLOSE_PLACEMENT_ADVICE]: handleReduce(state => ({
            ...state,
            placementAdvice: PLACEMENT_ADVICE_TYPES.SHOWN
        })),
        [FINISH_INSTALL_DEVICES]: handleReduce(state => ({
            ...state,
            installInProgress: true
        })),
        [FINISHED_INSTALL_DEVICES]: handleReduce(state => ({
            ...state,
            installInProgress: false
        })),
        [START_ACQUIRE_DEVICES]: handleReduce((state, { payload: time }) => ({
            ...state,
            devices: [],
            errors: 0,
            finishedAcquiring: false,
            placementAdvice: PLACEMENT_ADVICE_TYPES.NOT_SHOWN,
            startTime: time
        })),
        [STOP_ACQUIRE_DEVICES]: handleReduce(state => ({
            ...state,
            errors: 0,
            finishedAcquiring: true,
            startTime: undefined
        })),
        [UNLOAD_INSTALL_DEVICES]: handleReduce(state => ({
            ...state,
            devices: []
        }))
    },
    initialState
);



// WEBPACK FOOTER //
// ./src/core/state/acquire-devices/index.js